@if ((settings$ | async); as settings) {
  <footer>
    <div class="footer-content">
      @if (settings.contact_phone || settings.contact_email || settings.facebook_url || settings.website_url) {
        <ul class="footer-links"
        >
          <li>
            <!-- phone -->
            @if (settings.contact_phone) {
              <a [href]="'tel://' + settings.contact_phone">
                <app-icon name="phone"
                          size="xs"/>
                {{ 'footer.call_us' | translate }} {{ settings.contact_phone }}
              </a>
            }
          </li>
          <li>
            <!-- email -->
            @if (settings.contact_email) {
              <a
                  [href]="'mailto:' + settings.contact_email">
                <app-icon name="email"
                          size="xs"/>
                {{ 'footer.send_email' | translate }}
              </a>
            }
          </li>
          <li>
            <!-- fb -->
            @if (settings.facebook_url) {
              <a
                  [href]="settings.facebook_url"
                  target="blank">
                <app-facebook-icon/>
                {{ 'footer.facebook_page' | translate }}
              </a>
            }
          </li>
          <li>
            @if (settings.instagram_url) {
              <a
                  [href]="settings.instagram_url"
                  target="blank">
                <app-instagram-icon/>
                {{ 'footer.instagram_page' | translate }}
              </a>
            }
          </li>
          <li>
            @if (settings.tiktok_url) {
              <a
                  [href]="settings.tiktok_url"
                  target="blank">
                <app-tiktok-icon/>
                {{ 'footer.tiktok_page' | translate }}
              </a>
            }
          </li>
          <li>
            @if (settings.linkedin_url) {
              <a
                  [href]="settings.linkedin_url"
                  target="blank">
                <app-linkedin-icon/>
                {{ 'footer.linkedin_page' | translate }}
              </a>
            }
          </li>
          <li>
            <!-- homepage -->
            @if (settings.website_url) {
              <a
                  [href]="settings.website_url"
                  target="blank">
                <app-icon name="home"
                          size="xs"/>
                {{ 'footer.home_page' | translate }}
              </a>
            }
          </li>
        </ul>
      }
      <!-- copyright -->
      <div class="copyright">
        <span>Copyright &copy; {{ currentYear }} </span>
        <span>~ </span>
        <span>{{ settings.name }}</span>
      </div>
    </div>
  </footer>
}
